import axios from 'axios';
import base64 from 'base-64';
import {
  MDBAlert,
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBSpinner,
  MDBSwitch,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane, MDBToast
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartProvider';
import { CategoryContext } from '../context/CategoryContext';
import { DomainContext } from '../context/DomainProvider';
import { GeographyContext } from '../context/GeographyProvider';
import { MiscContext } from '../context/MiscProvider';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import PrivacyPolicy from '../privacy/PrivacyPolicy';
import Dropdown from '../reusables/Dropdown';
import { PasswordAlertCard, getDomainsAndCategories, handlePasswordValidation, usePersistedState, validatePassword } from './../utils/Common';
import ForgotPasswordModal from './ForgotPasswordModal';
import ForgotUserIdModal from './ForgotUserIdModal';

const LoginRegister = ({
  setCheckingToken,
  isCreate,
  domainName,
  domainId,
  anonymousUser,
  handleIsUserCreateModalOpenToggle,
}) => {

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [title,setTitle] = useState(localStorage.getItem('ROLE'));
  const [password, setPassword] = useState("");
   const [passwordType, setPasswordType] = useState(false);
  const passwordInput = useRef();

  const togglePasswordVisibility = () => {
    setPasswordType(!passwordType);
  };
  const [repeatPassword, setRepeatPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { pp, setPp, orders, showAlert, alertMessage,  setForgotUserIdModalOpen, setDynamicMessageFromApiCall, setContactPage,  setDPM,  setPwdAlert, setForgotPasswordModalOpen, setTestimonials, setAlertMessage, setDocumentsMap, setCompaniesMap, setReceipts,setShowAlert } = useContext(MiscContext);
  const {setCategoryId,setCategoryImages,setIsCategoryFormSubmitted,setGroupedCategoriesByDomain,setSelectCategories} = useContext(CategoryContext);
  const {setDomainData,setDomainImages,setSelectDomains,setDomainId,setGroupedDomainsByDomain,setFirmId} = useContext(DomainContext);
  const {setLocation,setIPAddress,location,ipAddress,setCountry,setStateOptions} = useContext(GeographyContext);
  const {setImages, setAddresses, setPhones, setEmails, setUserProfile, setUid, isLoginRequired, setIsLoginRequired, tokenLoaded, setTokenLoaded ,groups,setRoles,setTitles} = useContext(UserProfileContext);
  const { setCart, setCartCount, setQty, setCartId, setAddedEntities, setDeliveryDate, setOrders, setPaymentInfo, setOrdersCount } = useContext(CartContext);
  const { setBasicOpen, business, isPricing, setIsPricing, setIsDark, setAvatar, setBusiness, setPermissions,pageData } = useContext(NavbarContext);
  const firm = localStorage.getItem('FIRM');
  let [ou, setOu] = useState(business === 'B2C' ? firm : '');
  const [userId, setUserId] = useState("");

  const [userCreated, setUserCreated] = useState(false);
  const [userCreatedAlert, setUserCreatedAlert] = useState(false);
  const [conflict, setConflict] = useState(false);
  const [conflictMessage, setConflictMessage] = useState("");
  const [activeTab, setActiveTab] = useState('tab-login');
  const [fillActive, setFillActive] = useState("tab-login");
  const [registerTabIndex, setRegisterTabIndex] = useState("-1");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isForgotUserId, setIsForgotUserId] = useState(false);
  const navigate = useNavigate();
  const authUrl = process.env.REACT_APP_AUTH_URL;
  const inventoryUrl = process.env.REACT_APP_INVENTORY_URL;
  const userIdInput = useRef();
  const registerFirstNameInput = useRef();
  const registerLastNameInput = useRef();
  const registerCompanyNameInput = useRef();
  const registerEmailInput = useRef();
  const registerRepeatPasswordInput = useRef();
  const registerPasswordInput = useRef();

  const [countDown, setCountDown] = useState(0);
  useEffect(() => {
    const isP = window.location.host.includes("x-trk") || window.location.host.includes('expenses')
    localStorage.setItem("isPricing",isP);
    setIsPricing(isP);
   },[isPricing, setIsPricing])
  const handleLoginTabOrder = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      if (document.activeElement === userIdInput.current) {
        passwordInput.current.focus();
      } else if (document.activeElement === passwordInput.current) {
        userIdInput.current.focus();
      }
    }
  };

  const handleRegisterTabOrder = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      console.log("Tab key pressed"); // Debugging line
  
      const registerInputFields = [
        registerFirstNameInput,
        registerLastNameInput,
        registerCompanyNameInput,
        registerEmailInput,
        registerPasswordInput,
        registerRepeatPasswordInput,
      ];
  
      // Remove undefined refs if the business is not B2B
      const filteredFields = registerInputFields.filter(ref => ref.current);
  
      let focusedIndex = filteredFields.findIndex(ref => ref.current === document.activeElement);
      console.log("Focused Index:", focusedIndex); // Debugging line
  
      if (focusedIndex !== -1) {
        let nextIndex = e.shiftKey
          ? (focusedIndex - 1 + filteredFields.length) % filteredFields.length
          : (focusedIndex + 1) % filteredFields.length;
  
        let nextElement = filteredFields[nextIndex].current;
        console.log("Next Element:", nextElement); // Debugging line
  
        if (nextElement) {
          nextElement.focus();
          nextElement.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
        }
      }
    }
  };
  
  /* global FB */

  const getIPAddress = useCallback(() => {
    return ipAddress || localStorage.getItem('ipAddress');
  }, [ipAddress])

  useEffect(() => {
    const registerInputFields = [
      registerFirstNameInput,
      registerLastNameInput,
      registerCompanyNameInput,
      registerEmailInput,
      registerPasswordInput,
      registerRepeatPasswordInput,
    ];
  
    const loginInputFields = [
      userIdInput,
      passwordInput,
    ];
  
    if (activeTab === 'tab-login') {
      // Set focus to first field and set tabIndex to 0 for all login fields
      userIdInput.current?.focus();
      loginInputFields.forEach(inputRef => {
        if (inputRef.current) {
          inputRef.current.tabIndex = 0;
        }
      });
  
      // Set tabIndex to -1 for all register fields
      registerInputFields.forEach(inputRef => {
        if (inputRef.current) {
          inputRef.current.tabIndex = -1;
        }
      });
    } else if (activeTab === 'tab-register') {
      // Set focus to first field and set tabIndex to 0 for all register fields
      registerFirstNameInput.current?.focus();
      registerInputFields.forEach(inputRef => {
        if (inputRef.current) {
          inputRef.current.tabIndex = 0;
        }
      });
  
      // Set tabIndex to -1 for all login fields
      loginInputFields.forEach(inputRef => {
        if (inputRef.current) {
          inputRef.current.tabIndex = -1;
        }
      });
    }
  
    if (isCreate) {
      setFillActive('tab-register');
      setOu(domainName);
    }
  }, [activeTab, domainName, isCreate]);
  

  const handleFillClick = (tabName) => {
    if (tabName !== fillActive) {
      setFillActive(tabName);
      setActiveTab(tabName);
  
      if (tabName === 'tab-login') {
        userIdInput.current?.focus();
      } else if (tabName === 'tab-register') {
        registerFirstNameInput.current?.focus();
      }
    }
  };
  


  const [showLoginAlert, setShowLoginAlert] = useState(false);

  const [alertColor, setAlertColor] = useState('red');
  const getApiUrl = (path, userId) => {

    console.log("function", process.env);
    const userIdPath = userId ? `/${userId}` : "";
    return `${authUrl}${path}${userIdPath}`;
  };

  const handleCreateUser = async (e) => {
    const jwtToken = localStorage.getItem('JWT-TOKEN');

    e.preventDefault();

    if (firstName && lastName && password && email && ou) {
      const formData = new FormData();
      let url = `${jwtToken ? inventoryUrl : authUrl}/domains/userbyadmin?ipAddress=${getIPAddress()}`;
      let method = 'post';

      if (domainId) {
        ou = domainId;
      }
      let createUser = { firstName, lastName, email, password, ou ,title };
      createUser.title = title; 
      const userData = new File([JSON.stringify(createUser)], "user", { type: "application/json" });
      formData.append('user', userData);

      try {
        await axios({
          method: method,
          url: `${url}`,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          withCredentials: true,
        }).then((response) => {
          // setDomainData(prevState => ({
          //   ...prevState,
          //   users: [...prevState.users, response.data],
          // }));

          setDomainData(prevState => ({
            ...prevState,
            users: Array.isArray(prevState.users) ? [...prevState.users, response.data] : [response.data],
          }));
          setUid(userId)
          setFirmId(response.data?.firm);
          setDomainId(response.data?.domain);
          
          console.log(response.data);
          setFillActive("tab-login");
          setActiveTab("tab-login");
          setUserId(response.data.uid);
          setUserCreated(true);
          setTimeout(() => {
            handleIsUserCreateModalOpenToggle && handleIsUserCreateModalOpenToggle();
          }, 5000);

          // Add the firmId to the user data
        });
      } catch (error) {
        console.error(error);
        // setPwdAlert(false);
      }
    }
    //  setPwdAlert(false);
  };
  usePersistedState('uid', userId,tokenLoaded);
  const handleSignup = (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevents function from proceeding if already submitting

    setIsSubmitting(true); // Disable further submissions
    //clearNetworkData();
    handlePasswordValidation(e, password, repeatPassword, setAlertMessage, setAlertColor, setPwdAlert);
    if (!validatePassword(password) || password !== repeatPassword) {
      setConflictMessage(alertMessage)
      setConflict(true);
      setIsSubmitting(false);
      // setPwdAlert(false);
      return; // Stop signup process if validation fails
    }

    const url = (business === 'B2C') ? getApiUrl("/users/userForB2c") : getApiUrl("/users");

    axios.post(url, { firstName, lastName, email, password, ou }, { withCredentials: true })
      .then((response) => {
        console.log('Response:', response);
        if (response.status === 200) {
          setFillActive("tab-login");
          setActiveTab("tab-login");
          setUserId(response.data.uid);
          setPassword('');
          setRepeatPassword('');
          setPwdAlert(false);
          setUserCreated(true);
          setUserCreatedAlert(true);
          setAlertMessage('User Created');
          setIsSubmitting(false);
          //  toggleShowStartButtons();
        }
      }).catch((error) => {
        setIsSubmitting(false);
        console.log('Error:', error);
        console.error("Error while creating user", error);
        if (error.response && error.response.status === 409) {
          setConflictMessage(error.response.data.message);
          setConflict(true);
          setIsSubmitting(false);
        }
      });
  }

  const handleLoginButton = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevents function from proceeding if already submitting

    setIsSubmitting(true);
    clearNetworkData();
    setAddedEntities([]);
    setShowLoginAlert(false);

    const credentials = base64.encode(`${anonymousUser || userId}:${password}`);
    axios.get(getApiUrl("/users/valid"), {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem('DOMAIN', response.data.domain);
          setDomainId(response.data.domain);
          const token = response.data.token;
          localStorage.removeItem('CART-ID');
          setCartId(null);
         
          // setupIdleTimer();
          setUid(userId)
          const role = response.data.role;
          const permissions = response?.data?.permissions;
          setPermissions(permissions);
          setRoles(response?.data?.permissions?.roles);
          setTitles(response?.data?.permissions?.titles)
          response.data.avatar && setAvatar(response.data.avatar);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          localStorage.setItem('JWT-TOKEN', token);
          localStorage.setItem('ROLE', role);
          localStorage.setItem('SUBSCRIPTION', permissions?.role);
          localStorage.setItem('FIRM', response.data.firm);
          setDomainId(response.data?.domain);
          setFirmId(response.data?.firm);
          localStorage.setItem('AVATAR', response.data.avatar);
          localStorage.setItem('LOGO', pageData?.logo);
          setAvatar(response.data.avatar);
          //getDomainsAndCategories(response.data.domain);
          setTokenLoaded(true);

          setIsSubmitting(false);
          getDomainsAndCategories(response.data.domain, location, ipAddress,  tokenLoaded, setBusiness, setCountry,  setSelectCategories, setSelectDomains, setGroupedCategoriesByDomain, setCategoryImages, setGroupedDomainsByDomain, setDomainImages,setDomainId,setFirmId);

          if (response.data.isFirst && role === 'admin') {
            navigate('/domain');
          } else {
            navigate('/home');
          }
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error('Error while logging in', error);
        setIsLoginRequired(true);
        if (error.response) {
          if (error.response.status === 401) {
            setShowLoginAlert(true);
            setAlertMessage('Unauthorized: Invalid credentials provided');
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error('No response received', error.request);
          setShowLoginAlert(true);
          setAlertMessage('Unauthorized: Invalid credentials provided');
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Error', error.message);
          setShowLoginAlert(true);
          setAlertMessage('Something went wrong. Please try again.');
        }

        //toggleLoginModal()
      });
  }

  const clearNetworkData = async () => {
    try {
      if ('caches' in window) {
        const cacheKeys = await window.caches.keys();
        const deletePromises = cacheKeys.map(key => window.caches.delete(key));
        await Promise.all(deletePromises);
      } else {
        console.warn('Caches API is not available in this browser.');
      }

      // Clear specific data related to domains and categories
      localStorage.removeItem('DOMAIN');
      localStorage.removeItem('FIRM');
      localStorage.removeItem('CART-ID');
      localStorage.removeItem("SUBSCRIPTION");
      localStorage.removeItem('cartCount');
     // localStorage.clear();
     // localStorage.setItem('LOGO', pageData?.logo);
      setDomainData([]);
      setAvatar(undefined);
      setIsLoginRequired(false);
      setPermissions(undefined)
      setForgotUserIdModalOpen(false);
      setAddedEntities([]);
      setCartId(undefined);
      setTokenLoaded(false);
      setDynamicMessageFromApiCall(undefined);
      setSelectDomains([]);
      setQty(0);
      setPp(false);
      setSelectCategories([]);
      setCategoryImages([]);
      setCartCount(0);
      setCategoryId(undefined);
      setAddresses([]);
      setPhones([]);
      setEmails([]);
      setUserProfile(undefined);
      setCart(undefined);
      setOrders([]);
      setContactPage(undefined);
      setUid(undefined);
      setBasicOpen(false);
      setLocation(undefined);
      setPaymentInfo(undefined);
      setIPAddress(undefined);
      setStateOptions(undefined);
      setDPM(undefined);
      setDeliveryDate(undefined);
      setPwdAlert(false);
      setForgotPasswordModalOpen(false);
      setTestimonials([]);
      setAlertMessage(undefined);
      setIsCategoryFormSubmitted(false);
      setIsPricing(false);
      setIsDark(false);
      setDocumentsMap({});
      setCompaniesMap({});
      setImages([]);
      setReceipts([]);
      setShowAlert(false);
      setOrdersCount(0);

      localStorage.setItem('LOGO', pageData?.logo);
    } catch (error) {
      console.error('Error clearing network data:', error);
    }
  };


  const [ppSwitchValue, setPpSwitchValue] = useState(false);
  const handleSwitchChange = (e) => {
    // Capture the new state of the switch
    const newState = e.target.checked;
    // Update the privacyPolicy state
    setPpSwitchValue(newState);

    // You can perform additional actions based on the newState here
    // For example:
    if (newState) {
      console.log('Switch turned ON');
      // Perform actions when switch is turned ON
    } else {
      console.log('Switch turned OFF');
      // Perform actions when switch is turned OFF
    }
  };

  const generateUniqueId = (baseId) => `${baseId}-${Math.random().toString(36).slice(2, 9)}`;

  const loginNameId = generateUniqueId('loginName_signIn');

  return (
    <>
      <PrivacyPolicy privacyPolicy={pp} setPrivacyPolicy={setPp} />

      <MDBContainer>
        <MDBCard className='w-50 '>
          <MDBAlert className='w-100' color='success' open={showAlert && alertMessage.includes('SUCCESS')} autohide={true} delay={60000}>
            <i className="fas fa-check-circle me-3"></i>{alertMessage} <MDBBtn className='btn-close ms-3' onClose={() => setShowAlert(false)}></MDBBtn>
          </MDBAlert>

          <MDBCardBody className="p-5">
            <MDBTabs pills fill justify className="mb-3">
              {!isCreate &&
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => { handleFillClick("tab-login") }}
                    onKeyDown={(e) => { if (e.key === 'Enter') handleFillClick("tab-login") }}
                    active={fillActive === "tab-login"}
                  >
                    Login
                  </MDBTabsLink>
                </MDBTabsItem>
              }
              {!isPricing && business !== 'B2C' &&<MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleFillClick("tab-register")}
                  onKeyDown={(e) => { if (e.key === 'Enter') handleFillClick("tab-register") }}
                  active={fillActive === "tab-register"}
                >
                  {isCreate ? 'Create User' : 'Register'}
                </MDBTabsLink>
              </MDBTabsItem>}
            </MDBTabs>

            <MDBTabsContent>
              <MDBTabsPane
                open={fillActive === "tab-login"}
                aria-labelledby="tab-login"
              >
                <div>
                  <MDBInput
                    ref={userIdInput}
                    className="mb-4"
                    type="text"
                    id={loginNameId}
                    label="userId *"
                    value={anonymousUser || userId}
                    onChange={(e) => setUserId(e.target.value)}
                    onKeyDown={handleLoginTabOrder}
                  />
 <div style={{ position: 'relative' }}>
      <MDBInput
        ref={passwordInput}
        className="mb-4"
        type={passwordType ? 'text' : "password"}
        id="loginPassword"
        label="Password *"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            // Add logic to handle login on Enter key
          }
        }}
      />
      <MDBBtn 
        tag='a' 
        color='none'  
        style={{ 
          color: '#3b5998', 
          position: 'absolute', 
          right: '15px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          cursor: 'pointer' 
        }} 
        className={`fas ${passwordType ? "fa-eye" : "fa-eye-slash"} trailing link`}
        onClick={togglePasswordVisibility}
      ></MDBBtn>
    </div>


                  {/* <MDBInput
                    ref={passwordInput}
                    className="mb-4"
                    type={passwordType ? 'text' : "password"}
                    id={loginPasswordId}
                    label="Password *"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleLoginTabOrder}
                  >
      <MDBBtn 
        tag='a' 
        color='none'  
        style={{ 
          color: '#3b5998', 
          position: 'absolute', 
          right: '15px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          cursor: 'pointer' 
        }} 
        className={`fas ${passwordType ? "fa-eye" : "fa-eye-slash"} trailing link`}
        onClick={togglePasswordVisibility}>
      </MDBBtn>
    </MDBInput> */}

<div className="d-flex flex-column align-items-center mb-4">

                  <MDBBtnGroup className="mb-4 gap-2 "shadow='0' >
                  <span className='link-black outline' color='link'>Forgot:</span>
                    
                      <a className='outline' color='link' href="#!" onClick={() => { setForgotUserIdModalOpen(true); setIsForgotUserId(true); setIsForgotPassword(false) }}>UserId?</a>
                      <a href="#!" color='link' onClick={() => { setForgotUserIdModalOpen(true); setIsForgotPassword(true); setIsForgotUserId(false) }}>Password?</a>
                    
                  </MDBBtnGroup>

                  {isSubmitting ?
                    <MDBBtn>
                      <MDBSpinner grow size='sm' output='status' tag='span' className='me-2' /> Registering
                    </MDBBtn> :
                    <MDBBtnGroup className="mb-4 gap-2">
                      <MDBBtn tabIndex={activeTab === 'tab-register' ? "-1" : "0"} disabled={!password || !userId} onClick={e => { handleLoginButton(e) }}>
                        Sign in
                      </MDBBtn>
                      <Link to={orders?.length > 0 ? `/order-view` : `/home`}>
                        <MDBBtn tabIndex={activeTab === 'tab-register' ? "-1" : "0"} color='danger' onClick={() => setIsLoginRequired(!isLoginRequired)}>close</MDBBtn>
                      </Link>
                    </MDBBtnGroup>
                  }
                  </div>

                  <div className="text-center color-success">
                    <p className="text-primary">
                      {isPricing ?
                        <MDBBtn color='link' onClick={() => { setIsLoginRequired(!isLoginRequired) }}>
                          <span className='text-capitalize text-black me-3'>Not a member?</span>
                          <Link to='/true'>Subscribe</Link>
                        </MDBBtn> :
                       business !== 'B2C' && <a className="text-primary ms-2" tabIndex={activeTab === 'tab-register' ? "-1" : "0"} href="#!" onClick={(e) => { e.preventDefault(); handleFillClick("tab-register"); }} onKeyDown={(e) => { if (e.key === 'Enter') handleFillClick("tab-register") }}>
                          Register
                        </a> 
                      }
                    </p>
                  </div>
                </div>

                {showLoginAlert &&
                  <MDBToast
                    color='primary'
                    open={showLoginAlert}
                    className='mx-auto'
                    autohide={true}
                    delay={2000}
                    headerContent={
                      <span className='text-primary me-auto text-light' dangerouslySetInnerHTML={{ __html: alertMessage }} />
                    }
                    bodyContent={
                      <span>
                        Please verify user and/or password. If you want to reset, please click <a style={{ color: 'white', fontWeight: 'bold' }} href="#!" onClick={() => { setForgotUserIdModalOpen(true); setIsForgotPassword(true) }}>here</a>.
                      </span>
                    }
                    onClick={() => setShowLoginAlert(false)}
                  />
                }

                <MDBAlert alert dismiss color="success" onClick={() => setUserCreated(false)} open={userCreated}>
                  <i className="fas fa-check-circle me-3"></i>UserID: <span style={{ fontSize: '3em' }}>{userId}</span>
                  <p>Mail Set to:  <span style={{ color: 'black' }}>{email}</span></p>
                  {!isCreate && <MDBBtn color='link' rippleColor='dark'>
                    close
                  </MDBBtn>}
                </MDBAlert>

                <ForgotPasswordModal
                  setCheckingToken={setCheckingToken}
                  countDown={countDown}
                  setCountDown={setCountDown}
                  setIsForgotUserId={setIsForgotUserId}
                  setIsForgotPassword={setIsForgotPassword}
                />

                <ForgotUserIdModal
                  isForgotPassword={isForgotPassword}
                  setIsForgotUserId={setIsForgotUserId}
                  isForgotUserId={isForgotUserId}
                  setIsForgotPassword={setIsForgotPassword}
                  setShowAlert={setShowAlert}
                  setAlertMessage={setAlertMessage}
                  setCountDown={setCountDown}
                  countDown={countDown}
                  showAlert={showAlert}
                  alertMessage={alertMessage}
                />
              </MDBTabsPane>
           {(!isPricing || isCreate)  &&    
           <MDBTabsPane open={fillActive === "tab-register"} aria-labelledby="tab-register">
  <MDBInput
    ref={registerFirstNameInput}
    className="mb-4"
    type="text"
    id="registerFirstName"
    label="First Name *"
    value={firstName}
    onChange={e => setFirstName(e.target.value)}
    onKeyDown={handleRegisterTabOrder}
  />
  <MDBInput
    ref={registerLastNameInput}
    className="mb-4"
    type="text"
    id="registerLastName"
    label="Last Name *"
    value={lastName}
    onChange={e => { setLastName(e.target.value); setOu(e.target.value) }}
    onKeyDown={handleRegisterTabOrder}
  />
{ business !== 'B2C' &&
    <MDBInput
      ref={registerCompanyNameInput}
      className="mb-4"
      type="text"
      id="registerCompanyName"
      label="Company Name *"
      value={isCreate ? domainName : ou}
      onChange={e => setOu(e.target.value)}
      onKeyDown={handleRegisterTabOrder}
    />}
  {tokenLoaded && <Dropdown label="Group *" name="title" defaultValue={localStorage.getItem('ROLE')} dataForDropDown={groups} onValueChange={setTitle} />}
  <MDBInput
    ref={registerEmailInput}
    className="mb-4 mt-4"
    type="email"
    id="registerEmail"
    label="Email *"
    value={email}
    onChange={e => setEmail(e.target.value)}
    onKeyDown={handleRegisterTabOrder}
  />
  {(password.trim() !== repeatPassword.trim()) && <PasswordAlertCard />}
  {/* <MDBInput
    ref={registerPasswordInput}
    className="mb-4 mt-2"
    type="password"
    id="registerPassword1"
    label="Password *"
    value={password}
    onChange={e => { setPassword(e.target.value); setPwdAlert(true) }}
    onKeyDown={handleRegisterTabOrder}
  /> */}
  <div style={{ position: 'relative' }}>
      <MDBInput
          ref={registerPasswordInput}
        className="mb-4"
        type={passwordType ? 'text' : "password"}
        id="registerPassword1"
       label="Password *"
        value={password}
        onChange={e => { setPassword(e.target.value); setPwdAlert(true) }}
        onKeyDown={handleRegisterTabOrder}
      />
      <MDBBtn 
        tag='a' 
        color='none'  
        style={{ 
          color: '#3b5998', 
          position: 'absolute', 
          right: '15px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          cursor: 'pointer' 
        }} 
        className={`fas ${passwordType ? "fa-eye" : "fa-eye-slash"} trailing link`}
        onClick={togglePasswordVisibility}
      ></MDBBtn>
    </div>
  {/* <MDBInput
    ref={registerRepeatPasswordInput}
    className="mb-4"
    type="password"
    id="registerRepeatPassword1"
    label="Repeat password *"
    value={repeatPassword}
    onChange={e => { setRepeatPassword(e.target.value); setPwdAlert(true) }}
    onKeyDown={handleRegisterTabOrder}
  /> */}

<div style={{ position: 'relative' }}>
      <MDBInput
          ref={registerRepeatPasswordInput}
        className="mb-4"
        type={passwordType ? 'text' : "password"}
        id="egisterRepeatPassword1"
       label="Repeat password *"
        value={repeatPassword}
        onChange={e => { setRepeatPassword(e.target.value); setPwdAlert(true) }}
        onKeyDown={handleRegisterTabOrder}
      />
      <MDBBtn 
        tag='a' 
        color='none'  
        style={{ 
          color: '#3b5998', 
          position: 'absolute', 
          right: '15px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          cursor: 'pointer' 
        }} 
        className={`fas ${passwordType ? "fa-eye" : "fa-eye-slash"} trailing link`}
        onClick={togglePasswordVisibility}
      ></MDBBtn>
    </div>


  {!isCreate && (
    <span className="d-flex p-1">
      <MDBSwitch
        defaultChecked
        id='flexSwitchCheckChecked'
        onClick={handleSwitchChange}
        label={<span className='text-dark'>I have read and agreed to the terms.*</span>}
        input
      />
      <MDBBtn tag='a' color='none' style={{ color: '#000000' }} floating onClick={() => setPp(true)}>
        <MDBIcon fas icon="file-contract" size='xl' />
      </MDBBtn>
    </span>
  )}
  {isSubmitting ? (
    <MDBBtn>
      <MDBSpinner grow size='sm' output='status' tag='span' className='me-2' /> Registering
    </MDBBtn>
  ) : (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <MDBBtn onClick={isCreate ? handleCreateUser : handleSignup} className="me-2" tabIndex={activeTab === 'tab-login' ? "-1" : "0"}
        disabled={ppSwitchValue || !firstName || !lastName || !ou || !password || !repeatPassword || !email || !validatePassword(password) || !validatePassword(repeatPassword)}>
        {isCreate ? 'Save' : 'Sign up'}
      </MDBBtn>
      <Link to={orders?.length > 0 ? `/order-view` : `/home`}>
        <MDBBtn tabIndex={activeTab === 'tab-register' ? "-1" : "0"} className='mx-2' color='danger' onClick={() => setIsLoginRequired(!isLoginRequired)}>close</MDBBtn>
      </Link>
    </div>
  )}
  <MDBAlert open={conflict && conflictMessage} dismiss color="success" onClick={() => { setConflict(false); setConflictMessage('') }}>
    <i className="fas fa-exclamation-circle me-3"></i> <span className='text-primary me-auto' dangerouslySetInnerHTML={{ __html: conflictMessage }} style={{ minWidth: '10rem', textAlign: 'left' }} />
    <MDBBtn color='link' rippleColor='dark' tabIndex={activeTab === 'tab-login' ? "-1" : "0"} />
  </MDBAlert>
</MDBTabsPane>
}

            </MDBTabsContent>
          </MDBCardBody>
          {/* <MDBCardFooter>
            <MDBBtn className='btn-close  float-end ' size='sm'  color='danger'  onClick={() => {setIsLoginRequired(!isLoginRequired);handleIsUserCreateModalOpenToggle && handleIsUserCreateModalOpenToggle()}}/>
          </MDBCardFooter> */}
        </MDBCard>
      </MDBContainer>
    </>
  );
};

LoginRegister.propTypes = {
  isCreate: PropTypes.bool,
  toggleLoginModal: PropTypes.func,
  setCheckingToken: PropTypes.func,
  domainName: PropTypes.string,
  domainId: PropTypes.string,
  isCheckout: PropTypes.bool,
  handleIsUserCreateModalOpenToggle: PropTypes.func,
  anonymousUser: PropTypes.string,
};
export default LoginRegister;
